import { AdornedInput, ComboboxInputProps } from '@zillow/constellation';
import { IconSearchOutline } from '@zillow/constellation';
import { Adornment } from '@zillow/constellation';
import { Input } from '@zillow/constellation';
import { Combobox, Flex } from '@zillow/constellation';
import { useListPagedAdminUsersQuery } from 'API/administration/AdminUsersAPI';
import React from 'react';
import styled from 'styled-components';
import { eAdminAccountStatus } from 'types/administration/userAdministration/IAdminUser';
import { useListRolesQuery } from 'API/roles/RolesApi';

export interface IExtraFiltersProps {
  flexDirection?: 'row' | 'column';
  onChangeUsersFilter: (users: string[]) => void;
  onChangeRolesFilter: (roles: string[]) => void;
  usersFilter: string[];
  rolesFilter: string[];
}

const StyledCombobox = styled(Combobox)`
  flex-grow: 1;
`;

export const ExtraFilters: React.FC<IExtraFiltersProps> = ({
  onChangeUsersFilter,
                                                             onChangeRolesFilter,
  usersFilter,
                                                             rolesFilter,
  flexDirection = 'row',
}) => {
  const renderInput = React.useCallback(
    ({ onClear, onTagClose, ...rest }: ComboboxInputProps) => (
      <AdornedInput
        input={<Input placeholder="Find a fruit" {...rest} autoComplete="off" />}
        rightAdornment={
          <Adornment>
            <IconSearchOutline />
          </Adornment>
        }
      />
    ),
    []
  );
  const { data: roles = [] } = useListRolesQuery();
  const roleOptions = roles.map((role) => ({ label: role.label, value: role.name }));
  const { data: adminUsers } = useListPagedAdminUsersQuery({
    status: eAdminAccountStatus.Active,
    fetchAll: true,
  });
  const teammates = adminUsers?.content.map((admin) => ({ label: admin.fullName, value: admin.id })) ?? [];
  return (
    <Flex gap={1} display={'flex'} flexDirection={flexDirection}>
      <StyledCombobox
        data-test-id="roles-filter"
        options={roleOptions}
        multiple
        defaultValue={[]}
        placeholder="Select Roles"
        value={rolesFilter}
        onChange={(newValues) => Array.isArray(newValues) && onChangeRolesFilter(newValues as string[])}
        showLabelForValue
        autoComplete={'off'}
        renderInput={renderInput}
      />
      <StyledCombobox
        data-test-id="users-filter"
        options={teammates}
        multiple
        defaultValue={[]}
        placeholder="Select People"
        value={usersFilter}
        onChange={(newValues) => Array.isArray(newValues) && onChangeUsersFilter(newValues)}
        showLabelForValue
        autoComplete={'off'}
        renderInput={renderInput}
      />
    </Flex>
  );
};
